<div class="tab-content" [class.loading]="isContentLoading">
  @if (isContentLoading) {
    <svg lucideLoaderCircle class="tab-loading-spinner lucide-spin"></svg>
  }
  @if (!isContentLoading && canViewAccountSettings) {
    <p class="double-margin-bottom">Manage your general Arpio account settings below.</p>
    @if (isInEnforcementMode) {
      <enforcement-mode-notice class="double-margin-bottom" />
    }
    @if (canEditAccountName) {
      <div class="account-name-field">
        <label for="account-name" class="control-label">Account name</label>
        <form class="flex-center-row full-width" [formGroup]="accountNameModel" (ngSubmit)="updateAccountName()">
          <input id="account-name" formControlName="name" class="arpio-input space full-width" focus-element />
          <button
            type="submit"
            busy-button
            [busy]="updatingAccountName"
            [done]="updatedAccountName"
            class="arpio-button margin-left"
            [disabled]="saveNameDisabled"
            data-cy="update-account-name-button"
          >
            Update
          </button>
        </form>
      </div>
    }
    <div class="settings-grid">
      @if (!canEditAccountName) {
        <span class="data-label">Account Name</span>
        <div>{{ accountDto?.name }}</div>
      }

      <span class="data-label">Account ID</span>
      <div>{{ accountService.accountId }}</div>
      @if (canDisplayEntitlementContent && !usageBillingAvailable) {
        <span class="data-label">Product Edition</span>
        <div>{{ accountService.productEdition }}</div>

        @if (canViewLicenseCount) {
          <span class="data-label">License Count</span>
          <div>
            @if (isOverLicensedBillableResourceCount) {
              Current consumption of {{ currentBillableResourceCount }} billable resources exceeds licensed count of
              {{ licencedBillableResourceCount }}.
            } @else {
              Consuming {{ currentBillableResourceCount }} of {{ licencedBillableResourceCount }} licensed billable
              resources.
            }
            @if (accountService.overageEnforcementEnabled) {
              <span>Overage enforcement is enabled.</span>
            }
            @if (isLoadingReport) {
              <br />
              <svg lucideLoaderCircle class="lucide-spin"></svg> Loading billable resources report...
            } @else {
              @if (this.reportRecordCountValue > 0) {
                <br />
                Download the <a href="{{ billableResourceReportUrlCsv() }}">report of billable resources</a>.
              }
            }
          </div>
        }

        @if (accountService.subscriptionExpired) {
          <span class="data-label">Subscription Status</span>
          <div>
            Expired on {{ accountService.subscriptionExpiration | date: 'shortDate' }}.
            <a target="_blank" [href]="accountService.marketplaceUrl">Purchase a new subscription</a>.
          </div>
        } @else {
          <span class="data-label">Subscription Expires</span>
          <div>{{ accountService.subscriptionExpiration | date: 'shortDate' }}</div>
        }
      }
    </div>
  }
</div>
